// extracted by mini-css-extract-plugin
export default {"displayPatientComparison":"DisplayPatientComparison_displayPatientComparison__mKoye"};